import { css } from '@emotion/react';
import { lighten } from '@mui/material/styles';

const EDIT_ICON_COLOR = '#9e9e9e';
const EDIT_ICON_HOVER_COLOR = '#757575';

const makeRadioInputStyles = (theme) => {
  return {
    textLinkContainer: css({
      textAlign: 'center',
      marginTop: '0.5rem',
      marginBottom: '0.5rem',
    }),
    textLink: css({
      fontWeight: 'bold',
      color: `${theme.mvf.palette.text.primaryTextColor} !important`,
      cursor: 'pointer',
      textDecoration: 'underline',
      textUnderlineOffset: '3px',
      textDecorationColor: theme.mvf.palette.text.primaryTextColor,
      fontSize: theme.mvf.fontSize.mini,
      [theme.breakpoints.up('mobileMedium')]: {
        fontSize: theme.mvf.fontSize.small,
      },
      [theme.breakpoints.up('tabletSmall')]: {
        fontSize: theme.mvf.fontSize.compact,
      },
      [theme.breakpoints.up('desktopMedium')]: {
        fontSize: theme.mvf.fontSize.medium,
      },
      '&:hover': {
        textDecoration: 'underline',
        textDecorationColor: theme.mvf.palette.text.primaryTextColor,
        color: `${lighten(
          theme.mvf.palette.text.primaryTextColor,
          0.3
        )} !important`,
      },
    }),
    radioContainer: css({
      marginTop: '1rem',
    }),
    // One row per answered question: the question on the left, the chosen
    // answer and Edit on the right, separated from the next by a rule.
    answeredLine: css({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 16,
      padding: '14px 0',
      borderBottom: `1px solid ${theme.mvf.palette.component.backButtonColor}`,
    }),
    answeredText: css({
      display: 'flex',
      flex: 1,
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 16,
      textAlign: 'left',
    }),
    answeredQuestion: css({
      fontSize: theme.mvf.fontSize.small,
      color: theme.mvf.palette.text.primaryTextColor,
    }),
    answeredValue: css({
      flexShrink: 0,
      fontSize: theme.mvf.fontSize.small,
      fontWeight: 600,
      color: theme.mvf.palette.text.secondaryTextColor,
    }),
    editButton: css({
      flexShrink: 0,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: 'none',
      background: 'none',
      // Padding (and the matching negative margin) widens the tap target beyond
      // the glyph without shifting the summary layout.
      padding: 8,
      margin: -8,
      cursor: 'pointer',
      color: EDIT_ICON_COLOR,
      '& svg': { fontSize: '1.5rem' },
      '&:hover': { color: EDIT_ICON_HOVER_COLOR },
    }),
  };
};

export default makeRadioInputStyles;
